import React from 'react';
import { InhouseMun2026 } from '../views';


const SchoolProgrampage = () => {
  return <InhouseMun2026 />;
};

export default SchoolProgrampage;